/* Publish by EComposer at 2026-01-24 12:06:00*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3y9o4n3gga4"]=  window.__ectimmers["ecom-3y9o4n3gga4"] || {};
if(!this.$el)return!1;const e=this.$el,o=e.closest(".ecom-product-form--single");if(!o)return!1;if(o&&this.settings.show_total_price){let m=function(f){c.innerHTML=window.EComposer.formatMoney(parseInt(c.getAttribute("data-price"))*parseInt(f.value))},g=function(f){setTimeout(()=>{m(f)},100),f.addEventListener("change",function(){m(f)})};const c=e.querySelector(".ecom-product-single__price--sale");let d=o.querySelector("#quantity");if(!c||!d)return;g(d),o.addEventListener("ecomQuantityType",function(){o.querySelector("#quantity"),d&&g(d)}),o.addEventListener("ecomVariantChange",function(f){if(f.detail.variant){const b=f.detail.variant,y=d?parseInt(d.value):1;c.setAttribute("data-price",b.price),y>1&&(c.innerHTML=window.EComposer.formatMoney(b.price*parseInt(y)))}})}const t=o.querySelector('[name="id"]'),i=e.querySelector(".ecom-product-single__add-to-cart--submit"),n=e.closest("form"),s=t?parseInt(t.getAttribute("ec-variants")):0,a=this.isLive&&(s>250||n.querySelector("[data-high-variant-product]"));if(!n)return;function r(){let c=null;const d=n.dataset.product_id;let m=null;if(d?m=n.querySelector("[data-selected-variant]")||n.querySelector("[id^=product-json-"+d+"]"):m=e.querySelector("[id^=addtocart-product-json]"),!m)return;try{c=JSON.parse(m.innerHTML)}catch(f){return}let g=null;if(a?g=c:g=c.variants.find(f=>f.available)||c.variants[0],g){const f=i.querySelector(".ecom-add-to-cart-text");if(!f)return;g.available==!1?(i.setAttribute("disabled","disabled"),f.innerText=i.dataset.textOutstock,i.classList.remove("ecom-product-single__pre-order")):g.inventory_quantity<=0&&g.inventory_policy=="continue"&&g.inventory_management&&(f.innerText=i.dataset.textPreOrder,i.classList.add("ecom-product-single__pre-order"))}}if(!this.isLive)o&&(t&&!t.classList.contains("ecom-product-single__picker-default-variant")?t.dispatchEvent(new window.Event("ecomUpdate")):r());else{let c=function(d){const m=o.querySelectorAll(".ecom-required--checkbox");m.length>0&&m.forEach(function(y){let v=y.querySelectorAll("input[type=checkbox]");if(v.length==0)return;let w=!1;v.forEach(function(z){z.checked&&(w=!0)}),w?v.forEach(function(z){z.required=!1}):v.forEach(function(z){z.required=!0})});const g=o.querySelectorAll(".ecom-product-single__property-file");let f=!1,b;g.length&&g.forEach(function(y){if(y.required&&(!y.value||y.value=="")){y.parentNode.parentNode.querySelector(".ecom-product-single-form--text-error").style.display="block",f=!0,b=y;return}else f=!1}),f&&(d.preventDefault(),d.stopPropagation(),b.scrollIntoView({behavior:"smooth",block:"center",inline:"nearest"}))};if((!n.querySelector("select[name=id]")||n.querySelector("select[name=id]")&&t.classList.contains("ecom-product-single__picker-default-variant"))&&r(),!t&&i&&i.dataset.variant_id){const d=document.createElement("input");d.type="hidden",d.value=i.dataset.variant_id,e.appendChild(d)}i.addEventListener("click",c)}const l=function(c){if(!e)return;const d=e.querySelector(".ecom-product-single__add-to-cart--submit");if(!d)return;let m=parseInt(c.settings.animation_loop_time)*1e3||6e3,g=1e3;window.__ectimmers["ecom-3y9o4n3gga4"]["364sp2msc"] = setInterval(function(){d.classList.add("animated"),setTimeout(function(){d.classList.remove("animated")},g)},m)};this.settings.animation&&l(this)

                    });
                    
                        document.querySelectorAll('.ecom-3y9o4n3gga4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3y9o4n3gga4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-60ng0cj10sq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-60ng0cj10sq', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3p3eqi0w4tf"]=  window.__ectimmers["ecom-3p3eqi0w4tf"] || {};
if(!this.$el)return;const e=this.$el,o=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),i=e.querySelector(".text-content.ecom-html");!i||(o&&o.addEventListener("click",()=>{i.classList.remove("ecom-text--is-mark"),i.style.maxHeight="",o.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{i.classList.add("ecom-text--is-mark"),i.style.maxHeight="var(--ecom-text-height)",t.style.display="none",o.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-3p3eqi0w4tf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3p3eqi0w4tf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4mb2u121xnc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4mb2u121xnc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6j1eldyp80n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6j1eldyp80n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ijc53uhgb4g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ijc53uhgb4g', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-j35rlqb1by"]=  window.__ectimmers["ecom-j35rlqb1by"] || {};
var n,s;let e=this.$el;if(!e)return;let o=e.querySelector("afterpay-placement.ecom-afterpay-integrate"),t=this.$el.closest(".ecom-product-form--single");if(t){let a=t.querySelector('[name="id"]');if(a&&a.dispatchEvent(new window.Event("ecomUpdate")),this.settings.show_total_price){const r=t.querySelector(".ecom-product-single__quantity-input"),l=e.querySelector(".ecom-product-single__price--sale");if(!l)return;r&&r.addEventListener("change",function(){l.innerHTML=window.EComposer.formatMoney(parseInt(l.getAttribute("data-price"))*parseInt(this.value))}),t.addEventListener("ecomVariantChange",function(c){if(c.detail.variant){const d=c.detail.variant,m=r?parseInt(r.value):1;l.setAttribute("data-price",d.price),m>1&&(l.innerHTML=window.EComposer.formatMoney(d.price*parseInt(m)))}})}}if(this.settings.enable_afterpay){let a=window.document.querySelector("#ecom-after-pay-script");if(window.afterpay_min=this.settings.lower_limit||1,a)a.dataset.analyticsEnabled=!0,a.dataset.min=(n=this.settings.lower_limit)!=null?n:1,a.dataset.max=(s=this.settings.upper_limit)!=null?s:1e3;else{let r=window.document.createElement("script");r.id="ecom-after-pay-script",r.dataset.analyticsEnabled=!0,r.dataset.min=this.settings.lower_limit||1,r.dataset.max=this.settings.upper_limit||1e3,r.src="https://js.afterpay.com/afterpay-1.x.js",window.document.head.appendChild(r)}o&&this.isLive&&window.jQuery&&window.Afterpay&&window.Afterpay.initProductPage&&window.Afterpay.initProductPage(window.jQuery)}let i=e.querySelector(".ecom-product-single__price--badges-sale");if(i&&i.dataset.haveSale=="true"){let a=i.dataset.sale,r=i.dataset.text;r=r.replace(/\{.*\}/g,a),i.innerHTML=r,i.style.display="block"}

                    });
                    
                        document.querySelectorAll('.ecom-j35rlqb1by').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j35rlqb1by', settings: {"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-um36lp24r"]=  window.__ectimmers["ecom-um36lp24r"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let o=this.$el;if(!o)return;function t(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function i(){let n=o.querySelector(".ecom-element.ecom-base-image"),s=o.closest(".core__row--columns");n&&(t(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){i()})

                    });
                    
                        document.querySelectorAll('.ecom-um36lp24r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-um36lp24r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i5bye3arkvo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i5bye3arkvo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2fuu226tggt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2fuu226tggt', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0knxq9corcwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0knxq9corcwd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nllb9ve9t7"]=  window.__ectimmers["ecom-nllb9ve9t7"] || {};
const $el = this.$el;
                const products_item = $el.querySelectorAll(
                    ".ecom-product-bundle__item"
                );
                const products_title_item = $el.querySelectorAll(".item-for-loop");
                if (products_item.leng == 0) {
                    return;
                }
                const handleVariantSelect = () => {
                    if (products_title_item) {
                        products_title_item.forEach((item, index) => {
                            let select_id = item.querySelector(
                                "select[name=ecom-product-bundle-select]"
                            );
                            let item_images = item.querySelectorAll(
                                ".ecom-product-bundle__image"
                            );

                            if (!select_id) return;
                            select_id.addEventListener("change", (e) => {
                                let selected_index =
                                    select_id.options[select_id.selectedIndex];

                                if (!selected_index) return;

                                let price =
                                    selected_index.getAttribute("data-price");
                                let compare_at_price =
                                    selected_index.getAttribute(
                                        "data-compare-price"
                                    ) || 0;
                                let image =
                                    selected_index.getAttribute("data-image");
                                let product_id = selected_index.value;

                                item.querySelector(
                                    "input[name=product_id]"
                                ).value = product_id;
                                item.querySelector(
                                    ".product-bundle__checkbox-input"
                                ).setAttribute("data-product-price", price);
                                item.querySelector(
                                    ".product-bundle__checkbox-input"
                                ).setAttribute(
                                    "data-product-compare_price",
                                    compare_at_price
                                );
                                handleTotalPrice();
                                updatePrice(price, compare_at_price, item);

                                let item_for_loop_horizontal = $el.querySelectorAll('.item-for-loop-horizontal');
                                item_images.forEach(item => item.classList.add('ecom-loading-image'));
                                if(image) {
                                    item_images.forEach(item => item.querySelector('img').setAttribute('src', image));
                                    if(item_for_loop_horizontal && item_for_loop_horizontal[index])
                                        item_for_loop_horizontal[index].querySelector('img').setAttribute('src', image)
                                }
                                item_images.forEach(item => item.querySelector('img').onload = () => {
                                    item_images.forEach(item => item.classList.remove('ecom-loading-image'));
                                })
                            });
                        });
                    }

                    function updatePrice(price, compare_at_price, el) {
                        const $price_regular = el.querySelector(
                            ".ecom-product-bundle__price--regular"
                        );
                        const $price = el.querySelector(
                            ".ecom-product-bundle__price--sale"
                        );

                        if ($price) {
                            $price.innerHTML =
                                window.EComposer.formatMoney(price);
                        }

                        if ($price_regular) {
                            $price_regular.innerHTML =
                                window.EComposer.formatMoney(compare_at_price);
                            if (
                                parseFloat(compare_at_price) > parseFloat(price)
                            ) {
                                $price_regular.style.display = "inherit";
                            } else {
                                $price_regular.style.display = "none";
                            }
                        }
                    }
                };

                const handleMainProductVariantSelect = () => {
                    if (products_title_item.length == 0) return;
                    const product_form = document.querySelector(
                        "form.ecom-product-form--single"
                    );
                    const main_select =
                        product_form.querySelector("select[name=id]");
                    const main_product_bundle =
                        products_title_item[0].querySelector(
                            "select[name=ecom-product-bundle-select]"
                        );

                    if (!main_select || !main_product_bundle) return;
                    //Main select event
                    main_select.addEventListener("change", (e) => {
                        let value = e.target.value;
                        if (value && value != main_product_bundle.value) {
                            main_product_bundle.value = value;
                            main_product_bundle.dispatchEvent(
                                new Event("change")
                            );
                        }
                    });

                    //Bundle main product selet event
                    main_product_bundle.addEventListener("change", (e) => {
                        let value = e.target.value;
                        if (value) {
                            main_select.value = value;
                            main_select.dispatchEvent(new Event("swatch"));
                        }
                    });
                };

                const handleATC = () => {
                    const $btn_atc = $el.querySelector(
                        ".ecom-product-bundle__atc-btn"
                    );
                    let items = [];

                    $btn_atc.addEventListener("click", (e) => {
                        e.preventDefault();
                        const _this = e.target;
                        $btn_atc.classList.add("ecom-loading");

                        $el.querySelectorAll("input[type=checkbox]").forEach(
                            (checkbox, index) => {
                                if (checkbox.checked) {
                                    let product_id = products_title_item[
                                        index
                                    ].querySelector(
                                        "input[name=product_id]"
                                    ).value;
                                    if (!product_id) return;

                                    let item = {
                                        id: product_id,
                                        quantity: 1,
                                    };

                                    items.push(item);
                                }
                            }
                        );

                        if (items.length > 0) {
                            fetch("/cart/add.js?sections=cart-notification-product,cart-notification-button,cart-icon-bubble,cart-drawer", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({ items }),
                            })
                                .then((response) => response.json())
                                .then((response) => {
                                    if (
                                        response.status &&
                                        response.status == 422
                                    ) {
                                        window.EComposer.showToast(
                                            response.description,
                                            "error"
                                        );
                                        $btn_atc.classList.remove(
                                            "ecom-loading"
                                        );
                                        items = [];
                                        return;
                                    }
                                    if (window.EComposer.ajaxCartSuccess)
                                        window.EComposer.ajaxCartSuccess(
                                            response
                                        );
                                    $btn_atc.classList.remove("ecom-loading");
                                    items = [];
                                })
                                .catch((error) => {
                                    console.error("Error:", error);
                                });
                        }
                    });
                };

                const handleTotalPrice = () => {
                    let total_price = 0;
                    let total_compare_price = 0;
                    const checkboxs = $el.querySelectorAll(
                        "input[type=checkbox]"
                    );

                    if (!checkboxs) return;

                    if (this.settings.layout == "horizontal") {
                        var list = $el.querySelectorAll(
                            ".ecom-product-bundle__product-list .ecom-product-bundle__item "
                        );
                        list.forEach(function (item) {
                            item.style.opacity = 0.4;
                        });
                    }

                    checkboxs.forEach((checkbox, index) => {
                        checkbox.parentElement.style.opacity = 0.4;
                        if (checkbox.checked) {
                            let price =
                                checkbox.getAttribute("data-product-price");
                            let compare_price = checkbox.getAttribute(
                                "data-product-compare_price"
                            );
                            if (price) total_price += parseFloat(price);
                            if (compare_price && compare_price != '0')
                                total_compare_price +=
                                    parseFloat(compare_price);
                            else if (price)
                                total_compare_price += parseFloat(price);

                            checkbox.parentElement.style.opacity = 1;

                            if (this.settings.layout == "horizontal") {
                                if (list && list[index])
                                    list[index].style.opacity = 1;
                            }
                        }
                    });
                    $el.querySelector(
                        ".ecom-product-bundle__price--total"
                    ).innerHTML = window.EComposer.formatMoney(total_price);
                    if(this?.settings?.show_compare_price)
                        $el.querySelector(".ecom-product-bundle__price--compare").innerHTML = total_compare_price > total_price ? window.EComposer.formatMoney(total_compare_price) : "";
                };

                const handleCheckbox = function () {
                    const checkboxs = $el.querySelectorAll(
                        "input[type=checkbox]"
                    );
                    checkboxs.forEach((checkbox) => {
                        checkbox.addEventListener("change", handleTotalPrice);
                    });
                };

                const handleAnimation = function (_this) {
                    if (!$el) return;

                    const $btn_wrapper = $el.querySelector(
                        ".ecom-product-bundle__atc-btn"
                    );
                    if (!$btn_wrapper) return;

                    let intervalTime =
                            parseInt(_this?.settings.animation_loop_time) *
                                1000 || 6000,
                        animTime = 1000;window.__ectimmers["ecom-nllb9ve9t7"]["glwbap23u"] = setInterval(function () {
                        $btn_wrapper.classList.add("animated");
                        setTimeout(function () {
                            $btn_wrapper.classList.remove("animated");
                        }, animTime);
                    }, intervalTime);
                };

                if (this.settings.animation) {
                    handleAnimation(this);
                }

                handleVariantSelect();
                handleMainProductVariantSelect();
                handleTotalPrice();
                handleCheckbox();
                if (!window.ECOM_LIVE) handleATC();

                    });
                    
                        document.querySelectorAll('.ecom-nllb9ve9t7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nllb9ve9t7', settings: {"layout":"vertical","show_compare_price":false,"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}